import { withCellStyles } from '../../utils';
import { CellStyle } from 'xlsx-js-style/types';
import { Rows } from '../../interfaces';
import { CompanyWithRoundsDTO } from 'src/app/domain/company/dto/CompanyWithRoundsDTO';
import { CompanyStages, OrganizationEmployeeMiniDTO } from '../../../company/dto/CompanyAuxiliary';

/**
 * Get data mapping.
 * By changing pay an attention for the `reversedCompanyMapping()`.
 *
 * @param c Company to map.
 */
/* eslint-disable @typescript-eslint/naming-convention */
const getNewMapping = (c: CompanyWithRoundsDTO): object => ({
  'Company name': c.name,
  'Old name': c.secondName,
  'Legal name': c.legalName,
  Registration: c.country,
  Industry: c.industry,
  group: c.companyGroup,
  'Company stage': CompanyStages[c.stage],
  'Responsible managers': setManagers(c.responsibleManagers),
  Website: c.webSite,
  Description: c.description,
});

const setManagers = (managers: OrganizationEmployeeMiniDTO[]): string => {
  return managers
    .filter((manager) => manager.chosen)
    .map((m) => m.item)
    .join(',\n');
};

/**
 * Prepares rows for companies.
 *
 * @param companies Companies list.
 * @param headers Table headers.
 * @returns prepared rows for companies.
 */
export const getCompaniesRows = (companies: CompanyWithRoundsDTO[], headers: string[]): Rows => {
  const rows: Rows = [];
  // current index of row, rows start after the headerRows
  const mappedToHeaders = companies.map((d) => getNewMapping(d));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      const cellValue = mapped[header];
      switch (header) {
        case 'Company name':
          row.push(withCellStyles(cellValue, leftCenteredBold));
          break;
        case 'Responsible managers':
          row.push(withCellStyles(cellValue, wrapText));
          break;
        case 'Description':
          if (!cellValue) {
            // adding index of row where description is null or empty to set default height in *name of your function*
            emptyDescriptionRowsIndexes.push(currentIndex);
          }
          row.push(withCellStyles(cellValue, wrapText));
          break;

        default:
          row.push(cellValue);
      }
    }
    currentIndex++;
    rows.push(row);
  }
  return rows;
};

/**
 * Prepare data for excel export by adding styles, etc.
 *
 * @param exportExcelData export data for all companies.
 * @param headers Headers of the table.
 * @returns complete data for excel - rows.
 */
export const getPreparedData = (companies: CompanyWithRoundsDTO[], headers: string[]): Rows => {
  const newData: Rows = [];

  // refresh array of indexes row where no description
  resetData();
  newData.push(headers);

  const activeRows = getCompaniesRows(companies, headers);
  newData.push(...activeRows);
  return newData;
};


const leftCenteredBold: CellStyle = {
  alignment: { horizontal: 'left', vertical: 'center' },
  font: { bold: true },
};

export const wrapText: CellStyle = {
  alignment: { wrapText: true },
};

// array of indexes row where no description
export let emptyDescriptionRowsIndexes = [];
let currentIndex = 1;

export const getDescIndexArray = (): any[] => emptyDescriptionRowsIndexes;


const resetData = (): void => {
  currentIndex = 1;
  emptyDescriptionRowsIndexes = [];
};

